const inlineData = `
\t<header data-inline-inject="true">
\t\t<h2>Gone traveling</h2>
\t\t<h3>Monthly travel news and inspiration</h3>
\t</header>

\t<div data-inline-inject="true">
\t\t<h3>Destination of the Month</h3>

\t\t<h4>Valletta</h4>

\t\t<figure class="image image-style-align-right">
\t\t\t<img alt="Picture of a sunlit facade of a Maltan building." src="https://www.finnair.com/resource/image/1441640/landscape_ratio16x9/750/422/a69a89ce065056c127930eed471a7d2b/dV/malta-hero-carousel-3.jpg">
\t\t\t<figcaption>It's siesta time in Valletta.</figcaption>
\t\t</figure>

\t\t<p>The capital city of <a href="https://en.wikipedia.org/wiki/Malta" target="_blank" rel="external">Malta</a> is the top destination this summer. It’s home to a cutting-edge contemporary architecture, baroque masterpieces, delicious local cuisine and at least 8 months of sun. It’s also a top destination for filmmakers, so you can take a tour through locations familiar to you from Game of Thrones, Gladiator, Troy and many more.</p>
\t</div>

\t<div class="demo-row">
\t\t<div class="demo-row__half">
\t\t\t<div data-inline-inject="true">
\t\t\t\t<h3>The three greatest things you learn from traveling</h3>
\t\t\t\t<p><a href="#">Find out more</a></p>
\t\t\t</div>
\t\t</div>

\t\t<div class="demo-row__half">
\t\t\t<div data-inline-inject="true">
\t\t\t\t<h3>Walking the capitals of Europe: Warsaw</h3>
\t\t\t\t<p><a href="#">Find out more</a></p>
\t\t\t</div>
\t\t</div>
\t</div>`;
export default inlineData;
